import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function DFHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-887">
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/dB8uUYkttQ3PwV9fLdUEr6/Group-1000002440.jpg)'
    }} data-id="element-888" />
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-black/60" data-id="element-889" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-890">
        <AnimateOnScroll className="w-full lg:w-[60%]" data-id="element-891">
          <div className="mb-6" data-id="element-892">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-893">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-894">
                Treatments
              </a>{' '}
              / Injectables
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-895">
            Be SEXY
          </span>

          <h1 className="text-[32px] sm:text-5xl lg:text-[64px] uppercase text-white tracking-tight mb-2 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-896">
            DERMAL FILLERS
          </h1>

          <p className="font-serif italic text-white/80 text-xl lg:text-2xl mb-8" data-id="element-897">
            in a nutshell
          </p>

          <div className="space-y-6" data-id="element-898">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-899">
              Fillers are both phenomenal and can also be a disaster that
              results in you not looking anything like yourself. Too much or in
              the wrong place leaves you looking worse than before or just
              'overdone.'
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-900">
              At Be CLINICAL, Dr. Fiona wants you to look your best!{' '}
              <span className="italic" data-id="element-901">
                'When people see you, they think "wow, you look great!" We don't
                want people to look at you and wonder how much filler you got!'
              </span>
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-902">
              When it comes to dermal fillers, Dr. Fiona explains,{' '}
              <span className="italic" data-id="element-903">
                'it's all about choosing the correct filler, the right amount
                and then using the proper injection technique.'
              </span>
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-904">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}